import { Log, Level, Logger } from 'ng2-logger';
import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import Moment from 'moment';
import * as Actions from '../constants/examSession';
import { IExamSessionListSetAction, IExamSessionSelectedSetAction, IExamSessionSetUpdate } from '../../models/action/examSession';
import { ExamEntryDateType } from '../../models/enums/ExamEntryDateType';
import { ExamScoringType } from '../../models/enums/ExamScoringType';
import { ISetExamSessionAddQuestionList, ISetExamSessionAddStudentList, ISetExamSessionMultiStudentList, ISetExamSessionPublishDatas, ISetExamSessionQuestionList, ISetExamSessionStudentList } from '../../models/action/examSessionAdd';

const _logger = Log.create('Exam Reducer');

const examSessionReducer = (state = GlobalState().examSession, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {...state};
    if (action.type === Actions.actions.SET_EXAM_SESSION_LIST) {
        const examSessionPageAction = action as IExamSessionListSetAction;
        newState.sessionList = examSessionPageAction.model.sessionList;
        newState.selectedSession = examSessionPageAction.model.firstSession;    
    }
    if (action.type === Actions.actions.SET_EXAM_SESSION_SELECTED) {
        const examSessionPageAction = action as IExamSessionSelectedSetAction;
        newState.selectedSession = examSessionPageAction.selectedSession;
    }
    if (action.type === Actions.actions.SET_EXAM_SESSION_UPDATE) {
        const examSessionPageActionPayload = action as IExamSessionSetUpdate;
        const examSessionPageAction = examSessionPageActionPayload && examSessionPageActionPayload.sessionData ? examSessionPageActionPayload.sessionData: null;

        newState.examSessionData = {
            name: examSessionPageAction && examSessionPageAction.name,
            examScoringType: examSessionPageAction && examSessionPageAction.examScoringType,
            examSessionBeginDate: examSessionPageAction && examSessionPageAction.examSessionBeginDate,
            examSessionEndDate: examSessionPageAction && examSessionPageAction.examSessionEndDate,
            autoEnroll: examSessionPageAction && examSessionPageAction.autoEnroll,
            examSessionId: examSessionPageAction && examSessionPageAction.examSessionId
        };
    }
    if (action.type === Actions.actions.SET_EXAM_SESSION_UPDATE_DEFAULT) {
        newState.examSessionData = {
            examScoringType: ExamScoringType.LastAttempt,
            autoEnroll: true
        };
        
        newState.addQuestionDatas= {
                filters: {},
                results: []
            };

        newState.questionDatas= {
                filters: {},
                results: []
            };

        newState.studentDatas= {
                filters: {},
                results: []
            };
    }
    if (action.type === Actions.actions.GET_EXAM_SESSION_ADD_QUESTION_LIST_DEFAULT) {     
        newState.addQuestionDatas= {
                filters: {},
                results: []
            };
        newState.isDefaultUpdateQuestion = state.isDefaultUpdateQuestion + 1;
    } 
    if (action.type === Actions.actions.SET_EXAM_SESSION_LIST_DEFAULT) {
        newState.sessionList = [];
        newState.selectedSession = {};
    }
    if(action.type === Actions.actions.SET_EXAM_SESSION_ADD_QUESTION_LIST) {
        const examSessionPageActionPayload = action as ISetExamSessionAddQuestionList;
        const results = examSessionPageActionPayload && examSessionPageActionPayload.results ? examSessionPageActionPayload.results: [];
        const filters = examSessionPageActionPayload && examSessionPageActionPayload.filters ? examSessionPageActionPayload.filters: {};
        
        newState.addQuestionDatas = {
            filters,
            results
        };
    }
    if(action.type === Actions.actions.SET_EXAM_SESSION_QUESTION_LIST) {
        const examSessionPageActionPayload = action as ISetExamSessionQuestionList;
        const results = examSessionPageActionPayload && examSessionPageActionPayload.results ? examSessionPageActionPayload.results: [];
        const filters = examSessionPageActionPayload && examSessionPageActionPayload.filters ? examSessionPageActionPayload.filters: {};
        
        newState.questionDatas = {
            filters,
            results
        };
    }
    if(action.type === Actions.actions.SET_EXAM_SESSION_ADD_STUDENT_LIST) {
        const examSessionPageActionPayload = action as ISetExamSessionAddStudentList;
        const results = examSessionPageActionPayload && examSessionPageActionPayload.results ? examSessionPageActionPayload.results: [];
        const filters = examSessionPageActionPayload && examSessionPageActionPayload.filters ? examSessionPageActionPayload.filters: {};
        
        newState.addStudentDatas = {
            filters,
            results
        };
    }
    if (action.type === Actions.actions.GET_EXAM_SESSION_ADD_STUDENT_LIST_DEFAULT) {     
        newState.addStudentDatas= {
                filters: {},
                results: []
            };
        newState.isDefaultUpdateStudent = state.isDefaultUpdateStudent + 1;
    } 
    if(action.type === Actions.actions.SET_EXAM_SESSION_STUDENT_LIST) {
        const examSessionPageActionPayload = action as ISetExamSessionStudentList;
        const results = examSessionPageActionPayload && examSessionPageActionPayload.results ? examSessionPageActionPayload.results: [];
        const filters = examSessionPageActionPayload && examSessionPageActionPayload.filters ? examSessionPageActionPayload.filters: {};
        
        newState.studentDatas = {
            filters,
            results
        };
    }
    if(action.type === Actions.actions.SET_EXAM_SESSION_PUBLISH_DATAS) {
        const examSessionPageActionPayload = action as ISetExamSessionPublishDatas;
        const publishDatas = examSessionPageActionPayload && examSessionPageActionPayload.publishDatas ? 
            examSessionPageActionPayload.publishDatas: 
            {
                isQuestionGraterThanZero: 0,
                isAvaible: 0,
                isPassive: 0,
                isSessionQuestionCountGraterEqualThanExamQuestionCount: 0,
                isValidSessionDates: 0,
                sessionEndDateIsNotExpired: 0,
                isStudentGraterThanZero: 0,
                prePopulateCount: 0,
                examUserCount: 0,
                isWeightingOk: 0,
                activeStatus: -1
            };
        newState.publishDatas = publishDatas;
    }
    if(action.type === Actions.actions.GET_EXAM_SESSION_STUDENT_CHECK_LIST_DATAS) {
        const examSessionPageActionPayload = action as ISetExamSessionMultiStudentList;
        let publishDatas = {};
        
        if (examSessionPageActionPayload)
        {
            if (examSessionPageActionPayload.results)
            {
                publishDatas = examSessionPageActionPayload.results
            }

        }
        newState.multiUsers = publishDatas;
    }
    
    return Object.assign({}, state, newState);
};

export default examSessionReducer;